module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/~/babel-runtime/core-js/array/from.js
// module id = 706
// module chunks = 0